import {resolveBackground} from '#core/utils/color-utils.js';

import {registerTileSchema} from '#core/application/schema-registry.js';

import {generatePriceBoostLabel} from '#core/application/modules/tiles/price-boost-label/index.js';
import {generatePriceBoostItem} from '#core/application/modules/tiles/price-boost-item/index.js';

import PRICE_BOOST_BANNER from './price-boost-banner.palette-schema.yaml';

registerTileSchema(PRICE_BOOST_BANNER);

export function generatePriceBoostBanner(TILE) {
    const PRICE_BOOST_LABEL = generatePriceBoostLabel(TILE.PRICE_BOOST_BANNER_BOOST_LABEL);
    const PRICE_BOOST_ITEM = generatePriceBoostItem(TILE.PRICE_BOOST_BANNER_BOOST_ITEM);

    return {
        priceBoostContainer: {
            style: {
                ...resolveBackground(TILE.PRICE_BOOST_BANNER_CONTAINER_BG),
            },
        },
        priceBoostImage: PRICE_BOOST_LABEL.icon,
        priceBoostTitle: PRICE_BOOST_LABEL.label,
        basePriceContainer: {
            style: {
                alignItems: 'center',
            },
        },
        basePriceTitle: PRICE_BOOST_ITEM.wasTitle,
        basePriceAmount: PRICE_BOOST_ITEM.wasPrice,
        basePriceImage: PRICE_BOOST_ITEM.indicationIcon,
        selectionButton: PRICE_BOOST_ITEM.selectionButton,
    };
}
